var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.75C3.11812 0.75 0.375 3.49312 0.375 6.875C0.375 11.4688 6.5 18.25 6.5 18.25C6.5 18.25 12.625 11.4688 12.625 6.875C12.625 3.49312 9.88188 0.75 6.5 0.75ZM6.5 9.0625C5.2925 9.0625 4.3125 8.0825 4.3125 6.875C4.3125 5.6675 5.2925 4.6875 6.5 4.6875C7.7075 4.6875 8.6875 5.6675 8.6875 6.875C8.6875 8.0825 7.7075 9.0625 6.5 9.0625Z",
    fill: "#ABB6C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.a42ef0e33a8af29b14d66418d0d9eb9e.svg";
export { ForwardRef as ReactComponent };